// extracted by mini-css-extract-plugin
export default {"christine":"#e66609","screenXsMax":"(max-width: 768px)","Lato":"Lato, Helvetica, Arial, sans-serif","resetPassword":"styles_resetPassword__rZ9pf"};